import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  TextField,
} from "@mui/material";
import Button from "@mui/material/Button";
import capitalize from "lodash/capitalize";

import { awsRealTimeTxt } from "../../../../../assets/texts/Settings/aws";
import { isBucketNameValid } from "../../utils";

type StackCreationDialogProps = {
  open: boolean;
  operationName: string;
  setOpen: (boolean) => void;
  linkAccountHandler: () => void;
  bucketName: string;
  onBucketNameChange: (name: string) => void;
  showBucketNameInput: boolean;
};

export const StackCreationDialog = ({
  open,
  setOpen,
  operationName,
  linkAccountHandler,
  bucketName,
  onBucketNameChange,
  showBucketNameInput,
}: StackCreationDialogProps) => {
  const bucketNameIsValid = isBucketNameValid(bucketName);

  const handleBucketNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onBucketNameChange(e.target.value);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <DialogTitle>{awsRealTimeTxt.AWS_CLOUD_FORMATION_STACK_CREATION}</DialogTitle>
      <DialogContent>
        {showBucketNameInput && (
          <Box sx={{ mt: 1, mb: 1 }}>
            <TextField
              value={bucketName}
              onChange={handleBucketNameChange}
              fullWidth
              variant="outlined"
              label={awsRealTimeTxt.S3_BUCKET_NAME_LABEL}
              placeholder={awsRealTimeTxt.S3_BUCKET_NAME_PLACEHOLDER}
              required
              helperText={awsRealTimeTxt.REAL_TIME_DATA_BUCKET_NAME_ERROR_TXT}
              error={!bucketNameIsValid}
            />
          </Box>
        )}
        <DialogContentText>
          When you click "{capitalize(operationName)}", you will be taken to the AWS console to create a CloudFormation
          stack template. Please acknowledge the action, and click "Create stack".
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
          color="primary"
        >
          {awsRealTimeTxt.CANCEL_BTN}
        </Button>
        <Button
          onClick={linkAccountHandler}
          color="primary"
          variant="contained"
          startIcon={<OpenInNewIcon />}
          disabled={showBucketNameInput && (bucketName === "" || !bucketNameIsValid)}
        >
          {capitalize(operationName)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
